import React, { useRef, useEffect, useState } from 'react';

const RichTextEditor = ({ value, onChange, placeholder = '', className = '' }) => {
  const editorRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(!value || value === '' || value === '<br>');

  useEffect(() => {
    if (editorRef.current && value !== editorRef.current.innerHTML) {
      editorRef.current.innerHTML = value || '';
      setIsEmpty(!value || value === '' || value === '<br>' || (editorRef.current.innerText && editorRef.current.innerText.trim() === ''));
    }
  }, [value]);

  const handleInput = () => {
    if (editorRef.current && onChange) {
      const content = editorRef.current.innerHTML;
      onChange(content);
      setIsEmpty(!content || content === '' || content === '<br>' || editorRef.current.innerText.trim() === '');
    }
  };

  const executeCommand = (command, value = null) => {
    document.execCommand(command, false, value);
    editorRef.current?.focus();
    handleInput();
  };

  return (
    <div className={`border border-lightgray rounded flex flex-col ${className}`}>
      {/* Toolbar */}
      <div className="border-b border-lightgray p-2 flex flex-wrap gap-2 bg-gray-50 flex-shrink-0">
        <button
          type="button"
          onClick={() => executeCommand('bold')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Bold"
        >
          <strong>B</strong>
        </button>
        <button
          type="button"
          onClick={() => executeCommand('italic')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Italic"
        >
          <em>I</em>
        </button>
        <button
          type="button"
          onClick={() => executeCommand('underline')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Underline"
        >
          <u>U</u>
        </button>
        <div className="border-l border-lightgray mx-1" />
        <button
          type="button"
          onClick={() => executeCommand('formatBlock', '<h1>')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Heading 1"
        >
          H1
        </button>
        <button
          type="button"
          onClick={() => executeCommand('formatBlock', '<h2>')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Heading 2"
        >
          H2
        </button>
        <button
          type="button"
          onClick={() => executeCommand('formatBlock', '<p>')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Paragraph"
        >
          P
        </button>
        <div className="border-l border-lightgray mx-1" />
        <button
          type="button"
          onClick={() => executeCommand('insertUnorderedList')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Bullet List"
        >
          • List
        </button>
        <button
          type="button"
          onClick={() => executeCommand('insertOrderedList')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Numbered List"
        >
          1. List
        </button>
        <div className="border-l border-lightgray mx-1" />
        <button
          type="button"
          onClick={() => executeCommand('justifyLeft')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Align Left"
        >
          ⬅
        </button>
        <button
          type="button"
          onClick={() => executeCommand('justifyCenter')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Align Center"
        >
          ⬌
        </button>
        <button
          type="button"
          onClick={() => executeCommand('justifyRight')}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Align Right"
        >
          ➡
        </button>
        <div className="border-l border-lightgray mx-1" />
        <button
          type="button"
          onClick={() => {
            const url = prompt('Enter URL:');
            if (url) executeCommand('createLink', url);
          }}
          className="px-3 py-1 text-sm border border-lightgray rounded hover:bg-gray-200"
          title="Insert Link"
        >
          🔗 Link
        </button>
      </div>
      {/* Editor */}
      <div style={{ position: 'relative', flex: '1 1 auto', overflow: 'hidden' }}>
        <div
          ref={editorRef}
          contentEditable
          onInput={handleInput}
          className="min-h-[300px] max-h-[500px] p-4 text-offblack focus:outline-none overflow-y-auto"
          style={{ whiteSpace: 'pre-wrap' }}
        />
        {isEmpty && placeholder && (
          <div
            style={{
              position: 'absolute',
              top: '16px',
              left: '16px',
              color: '#999',
              pointerEvents: 'none',
            }}
          >
            {placeholder}
          </div>
        )}
      </div>
    </div>
  );
};

export default RichTextEditor;

